type ToastTone = 'error' | 'info' | 'success';

let activeToast: HTMLDivElement | null = null;
let removeTimer = 0;
let audioContext: AudioContext | null = null;

function getAudioContext() {
  if (audioContext) {
    return audioContext;
  }

  const AudioContextCtor = window.AudioContext
    || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;

  if (!AudioContextCtor) {
    return null;
  }

  audioContext = new AudioContextCtor();
  return audioContext;
}

function playTone(frequency: number, durationMs: number, delayMs = 0) {
  window.setTimeout(() => {
    const ctx = getAudioContext();

    if (!ctx) {
      return;
    }

    if (ctx.state === 'suspended') {
      void ctx.resume();
    }

    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    const now = ctx.currentTime;
    const duration = durationMs / 1000;

    oscillator.type = 'sine';
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.12, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);

    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.start(now);
    oscillator.stop(now + duration);
  }, delayMs);
}

function vibrate(durationMs: number) {
  if (navigator.vibrate) {
    navigator.vibrate(durationMs);
  }
}

function removeToast() {
  if (removeTimer) {
    window.clearTimeout(removeTimer);
    removeTimer = 0;
  }

  activeToast?.remove();
  activeToast = null;
}

export function showToast(message: string, tone: ToastTone = 'info', durationMs = 2000) {
  removeToast();

  const div = document.createElement('div');
  const palette = {
    error: '#c62828',
    info: '#334455',
    success: '#218739',
  };

  div.textContent = message;
  Object.assign(div.style, {
    background: palette[tone],
    borderRadius: '8px',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.18)',
    color: '#fff',
    fontSize: '14px',
    left: '50%',
    maxWidth: '320px',
    padding: '12px 16px',
    position: 'fixed',
    textAlign: 'center',
    top: '20%',
    transform: 'translateX(-50%)',
    zIndex: '9999',
  });

  activeToast = div;
  document.body.appendChild(div);
  removeTimer = window.setTimeout(removeToast, durationMs);
}

export function signalSuccess() {
  playTone(200, 100);
  vibrate(50);
}

export function signalError() {
  playTone(140, 160);
  playTone(120, 160, 220);
  vibrate(200);
}

export function notifySuccess(message: string) {
  signalSuccess();
  showToast(message, 'success');
}

export function notifyError(message: string) {
  signalError();
  showToast(message, 'error');
}

export function notifyInfo(message: string) {
  showToast(message, 'info');
}
